import React from "react";
import { connect } from "alt-react";
import classNames from "classnames";
import AccountActions from "actions/AccountActions";
import AccountStore from "stores/AccountStore";
import AccountNameInput from "./../Forms/AccountNameInputStyleGuide";
import PasswordInput from "./../Forms/PasswordInput";
import WalletDb from "stores/WalletDb";
import { Link } from "react-router-dom";
import AccountSelect from "../Forms/AccountSelect";
import WalletUnlockActions from "actions/WalletUnlockActions";
import TransactionConfirmStore from "stores/TransactionConfirmStore";
import LoadingIndicator from "../LoadingIndicator";
import WalletActions from "actions/WalletActions";
import Translate from "react-translate-component";
import { ChainStore, FetchChain } from "bitsharesjs";
import { BackupCreate } from "../Wallet/Backup";
import ReactTooltip from "react-tooltip";
import utils from "common/utils";
import SettingsActions from "actions/SettingsActions";
import counterpart from "counterpart";
import { withRouter } from "react-router-dom";
import { scroller } from "react-scroll";
import { getWalletName } from "branding";
import { Notification } from "bitshares-ui-style-guide";

class CreateAccount extends React.Component {
  constructor() {
    super();
    this.state = {
      validAccountName: false,
      accountName: "",
      validPassword: false,
      registrar_account: null,
      loading: false,
      hide_refcode: true,
      show_identicon: false,
      step: 1,
      passwordInputVisible: false
    };
    this.onFinishConfirm = this.onFinishConfirm.bind(this);
    this.accountNameInput = null;
    this.scrollToInput = this.scrollToInput.bind(this);
  }

  UNSAFE_componentWillMount() {
    SettingsActions.changeSetting({
      setting: "passwordLogin",
      value: false
    });
  }

  componentDidMount() {
    ReactTooltip.rebuild();
    this.scrollToInput();
  }

  shouldComponentUpdate(nextProps, nextState) {
    return !utils.are_equal_shallow(nextState, this.state);
  }

  isValid() {
    let firstAccount = AccountStore.getMyAccounts().length === 0;
    let valid = this.state.validAccountName;

    if (!WalletDb.getWallet()) {
      valid = valid && this.state.validPassword;
    }

    if (!firstAccount) {
      valid = valid && this.state.registrar_account;
    }

    return valid;
  }

  onAccountNameChange(e) {
    const state = {};
    if (e.valid !== undefined) state.validAccountName = e.valid;
    if (e.value !== undefined) state.accountName = e.value;
    if (!this.state.show_identicon) state.show_identicon = true;
    this.setState(state);
  }

  onPasswordChange(e) {
    this.setState({
      validPassword: e.valid,
      passwordInputVisible: e.visible
    });
  }

  onFinishConfirm(confirm_store_state) {
    if (confirm_store_state.included && confirm_store_state.broadcasted_transaction) {
      TransactionConfirmStore.unlisten(this.onFinishConfirm);
      TransactionConfirmStore.reset();
      FetchChain("getAccount", this.state.accountName, undefined, {
        [this.state.accountName]: true
      }).then(() => {
        console.log("onFinishConfirm");
        this.props.history.push("/wallet/backup/create?newAccount=true");
      });
    }
  }

  scrollToInput() {
    scroller.scrollTo(`scrollToInput`, {
      duration: 1500,
      delay: 100,
      smooth: true,
      containerId: "accountForm"
    });
  }

  createAccount(name) {
    let refcode = this.refs.refcode ? this.refs.refcode.value() : null;
    let referralAccount = AccountStore.getState().referralAccount;
    WalletUnlockActions.unlock().then(() => {
      this.setState({
        loading: true
      });
      AccountActions.createAccount(name, this.state.registrar_account, referralAccount || this.state.registrar_account, 0, refcode).then(() => {
        // User registering his own account
        if (this.state.registrar_account) {
          FetchChain("getAccount", name, undefined, {
            [name]: true
          }).then(() => {
            this.setState({
              step: 2,
              loading: false
            });
          });
          TransactionConfirmStore.listen(this.onFinishConfirm);
        } else {
          // Account registered by the faucet
          FetchChain("getAccount", name, undefined, {
            [name]: true
          }).then(() => {
            this.setState({
              step: 2,
              loading: false
            });
          });
        }
      }).catch(error => {
        console.log("ERROR AccountActions.createAccount", error);
        let error_msg = error.base && error.base.length && error.base.length > 0 ? error.base[0] : "unknown error";
        if (error.remote_ip) error_msg = error.remote_ip[0];
        Notification.error({
          message: counterpart.translate("notifications.account_create_failure", {
            account_name: name,
            error_msg: error_msg
          })
        });
        this.setState({
          loading: false
        });
      });
    }).catch(() => {});
  }

  createWallet(password) {
    return WalletActions.setWallet("default", //wallet name
    password).then(() => {
      console.log("Congratulations, your wallet was successfully created.");
    }).catch(err => {
      console.log("CreateWallet failed:", err);
      Notification.error({
        message: counterpart.translate("notifications.account_wallet_create_failure", {
          error_msg: err
        })
      });
    });
  }

  onSubmit(e) {
    e.preventDefault();
    if (!this.isValid()) return;
    let account_name = this.accountNameInput.getValue();

    if (WalletDb.getWallet()) {
      this.createAccount(account_name);
    } else {
      let password = this.refs.password.value();
      this.createWallet(password).then(() => this.createAccount(account_name));
    }
  }

  onRegistrarAccountChange(registrar_account) {
    this.setState({
      registrar_account
    });
  } // showRefcodeInput(e) {
  //     e.preventDefault();
  //     this.setState({hide_refcode: false});
  // }


  _renderAccountCreateForm() {
    let {
      registrar_account
    } = this.state;
    let my_accounts = AccountStore.getMyAccounts();
    let firstAccount = my_accounts.length === 0;
    let hasWallet = WalletDb.getWallet();
    let valid = this.isValid();
    let isLTM = false;
    let registrar = registrar_account ? ChainStore.getAccount(registrar_account) : null;

    if (registrar) {
      if (registrar.get("lifetime_referrer") == registrar.get("id")) {
        isLTM = true;
      }
    }

    let buttonClass = classNames("submit-button button no-margin", {
      disabled: !valid || registrar_account && !isLTM
    });
    return /*#__PURE__*/React.createElement("form", {
      style: {
        maxWidth: "40rem"
      },
      onSubmit: this.onSubmit.bind(this),
      noValidate: true,
      className: "create-account-wrapper"
    }, /*#__PURE__*/React.createElement("p", {
      style: {
        fontWeight: "normal",
        fontFamily: "Roboto-Medium, arial, sans-serif",
        fontStyle: "normal"
      }
    }, firstAccount ? /*#__PURE__*/React.createElement(Translate, {
      content: "wallet.create_w_a"
    }) : /*#__PURE__*/React.createElement(Translate, {
      content: "wallet.create_a"
    })), /*#__PURE__*/React.createElement(AccountNameInput, {
      ref: ref => {
        if (ref) {
          this.accountNameInput = ref.refs.nameInput;
        }
      },
      cheapNameOnly: !!firstAccount,
      onChange: this.onAccountNameChange.bind(this),
      accountShouldNotExist: true,
      placeholder: counterpart.translate("wallet.account_public"),
      noLabel: true
    }), hasWallet ? null : /*#__PURE__*/React.createElement(PasswordInput, {
      ref: "password",
      visible: this.state.passwordInputVisible,
      confirmation: true,
      onChange: this.onPasswordChange.bind(this),
      noLabel: true,
      checkStrength: true
    }), firstAccount ? null : /*#__PURE__*/React.createElement("div", {
      className: "full-width-content form-group no-overflow"
    }, /*#__PURE__*/React.createElement("label", null, /*#__PURE__*/React.createElement(Translate, {
      content: "account.pay_from"
    })), /*#__PURE__*/React.createElement(AccountSelect, {
      account_names: my_accounts,
      onChange: this.onRegistrarAccountChange.bind(this)
    }), registrar_account && !isLTM ? /*#__PURE__*/React.createElement("div", {
      style: {
        textAlign: "left"
      },
      className: "facolor-error"
    }, /*#__PURE__*/React.createElement(Translate, {
      content: "wallet.must_be_ltm"
    })) : null), /*#__PURE__*/React.createElement("div", {
      className: "divider"
    }), this.state.loading ? /*#__PURE__*/React.createElement(LoadingIndicator, {
      type: "three-bounce"
    }) : /*#__PURE__*/React.createElement("button", {
      style: {
        width: "100%"
      },
      className: buttonClass
    }, /*#__PURE__*/React.createElement(Translate, {
      content: "account.create_account"
    })), /*#__PURE__*/React.createElement("div", {
      style: {
        paddingTop: 40
      }
    }, /*#__PURE__*/React.createElement("label", null, /*#__PURE__*/React.createElement(Link, {
      to: "/existing-account"
    }, /*#__PURE__*/React.createElement(Translate, {
      content: "wallet.restore"
    }))), /*#__PURE__*/React.createElement("label", null, /*#__PURE__*/React.createElement(Link, {
      to: "/create-wallet-brainkey"
    }, /*#__PURE__*/React.createElement(Translate, {
      content: "settings.backup_brainkey"
    })))), !hasWallet || firstAccount ? null : /*#__PURE__*/React.createElement("div", {
      style: {
        paddingTop: 20
      }
    }, /*#__PURE__*/React.createElement("label", null, /*#__PURE__*/React.createElement("a", {
      onClick: () => {
        this.setState({
          step: 3
        });
      }
    }, /*#__PURE__*/React.createElement(Translate, {
      content: "wallet.go_get_started"
    })))));
  }

  _renderAccountCreateText() {
    let hasWallet = WalletDb.getWallet();
    let my_accounts = AccountStore.getMyAccounts();
    let firstAccount = my_accounts.length === 0;
    return /*#__PURE__*/React.createElement("div", {
      className: "confirm-checks"
    }, /*#__PURE__*/React.createElement("h4", {
      style: {
        fontWeight: "normal",
        fontFamily: "Roboto-Medium, arial, sans-serif",
        fontStyle: "normal",
        paddingBottom: 15,
        marginTop: 0
      }
    }, /*#__PURE__*/React.createElement(Translate, {
      content: "wallet.wallet_browser"
    })), /*#__PURE__*/React.createElement("p", null, !hasWallet ? /*#__PURE__*/React.createElement(Translate, {
      content: "wallet.has_wallet",
      wallet_name: getWalletName()
    }) : null), /*#__PURE__*/React.createElement(Translate, {
      style: {
        textAlign: "left"
      },
      component: "p",
      content: "wallet.create_account_text"
    }), firstAccount ? /*#__PURE__*/React.createElement(Translate, {
      style: {
        textAlign: "left"
      },
      component: "p",
      content: "wallet.first_account_paid"
    }) : /*#__PURE__*/React.createElement(Translate, {
      style: {
        textAlign: "left"
      },
      component: "p",
      content: "wallet.not_first_account"
    }));
  }

  _renderBackup() {
    return /*#__PURE__*/React.createElement("div", {
      className: "backup-submit"
    }, /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement(Translate, {
      unsafe: true,
      content: "wallet.wallet_crucial"
    })), /*#__PURE__*/React.createElement("div", {
      className: "divider"
    }), /*#__PURE__*/React.createElement(BackupCreate, {
      noText: true,
      downloadCb: this._onBackupDownload
    }));
  }

  _onBackupDownload = () => {
    this.setState({
      step: 3
    });
  };

  _renderBackupText() {
    return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("p", {
      style: {
        fontWeight: "normal",
        fontFamily: "Roboto-Medium, arial, sans-serif",
        fontStyle: "normal"
      }
    }, /*#__PURE__*/React.createElement(Translate, {
      content: "footer.backup"
    })), /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement(Translate, {
      content: "wallet.wallet_move",
      unsafe: true
    })), /*#__PURE__*/React.createElement("p", {
      className: "txtlabel warning"
    }, /*#__PURE__*/React.createElement(Translate, {
      unsafe: true,
      content: "wallet.wallet_lose_warning"
    })));
  }

  _renderGetStarted() {
    return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("table", {
      className: "table"
    }, /*#__PURE__*/React.createElement("tbody", null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(Translate, {
      content: "wallet.tips_dashboard"
    }), ":"), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(Link, {
      to: "/"
    }, /*#__PURE__*/React.createElement(Translate, {
      content: "header.dashboard"
    })))), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(Translate, {
      content: "wallet.tips_account"
    }), ":"), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(Link, {
      to: `/account/${this.state.accountName}/overview`
    }, /*#__PURE__*/React.createElement(Translate, {
      content: "wallet.link_account"
    })))), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(Translate, {
      content: "wallet.tips_deposit"
    }), ":"), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(Link, {
      to: "/deposit-withdraw"
    }, /*#__PURE__*/React.createElement(Translate, {
      content: "wallet.link_deposit"
    })))), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(Translate, {
      content: "wallet.tips_transfer"
    }), ":"), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(Link, {
      to: "/transfer"
    }, /*#__PURE__*/React.createElement(Translate, {
      content: "wallet.link_transfer"
    })))), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(Translate, {
      content: "wallet.tips_settings"
    }), ":"), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(Link, {
      to: "/settings"
    }, /*#__PURE__*/React.createElement(Translate, {
      content: "header.settings"
    })))))));
  }

  _renderGetStartedText() {
    return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("p", {
      style: {
        fontWeight: "normal",
        fontFamily: "Roboto-Medium, arial, sans-serif",
        fontStyle: "normal"
      }
    }, /*#__PURE__*/React.createElement(Translate, {
      content: "wallet.congrat"
    })), /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement(Translate, {
      content: "wallet.tips_explore"
    })), /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement(Translate, {
      content: "wallet.tips_header"
    })), /*#__PURE__*/React.createElement("p", {
      className: "txtlabel warning"
    }, /*#__PURE__*/React.createElement(Translate, {
      content: "wallet.tips_login"
    })));
  }

  render() {
    let {
      step
    } = this.state;
    return /*#__PURE__*/React.createElement("div", {
      className: "sub-content",
      id: "scrollToInput",
      name: "scrollToInput"
    }, /*#__PURE__*/React.createElement("div", {
      style: {
        maxWidth: "95vw"
      }
    }, step !== 1 ? /*#__PURE__*/React.createElement("p", {
      style: {
        fontWeight: "normal",
        fontFamily: "Roboto-Medium, arial, sans-serif",
        fontStyle: "normal"
      }
    }, /*#__PURE__*/React.createElement(Translate, {
      content: "wallet.step_" + step
    })) : null, step === 1 ? this._renderAccountCreateForm() : step === 2 ? this._renderBackup() : this._renderGetStarted()), /*#__PURE__*/React.createElement("div", {
      style: {
        maxWidth: "95vw",
        paddingTop: "2rem"
      }
    }, step === 1 ? this._renderAccountCreateText() : step === 2 ? this._renderBackupText() : this._renderGetStartedText()), /*#__PURE__*/React.createElement(Link, {
      to: "/"
    }, /*#__PURE__*/React.createElement("button", {
      className: "button primary hollow"
    }, /*#__PURE__*/React.createElement(Translate, {
      content: "wallet.back"
    }))));
  }

}

CreateAccount = withRouter(CreateAccount);
export default connect(CreateAccount, {
  listenTo() {
    return [AccountStore];
  },

  getProps() {
    return {};
  }

});